<template>
	<div class="view-content">
		<div class="view-content-info">
			<div class="user-login">
				<div class="user-login-title"><a href="/">首页</a> / <span>重置密码</span></div>
				<div class="user-login-content">
					<div class="forget-title">重置密码</div>
					<div class="forget-step flex-midden flex-center" v-if="step!=4">
						<div class="forget-step-active flex-start flex-center">
							<img src="@/assets/images/dui2.png"/>
							<div>填写账户名</div>
						</div>
						<div class="forget-step-dian flex-center flex-midden">
							<span :class="step >= 2?'active':''"></span>
							<span :class="step >= 2?'active':''"></span>
							<span :class="step >= 2?'active':''"></span>
							<span :class="step >= 2?'active':''"></span>
						</div>
						<div class="flex-start flex-center" :class="step >= 2?'forget-step-active':'forget-step-item'">
							<img v-if="step >= 2" src="@/assets/images/dui2.png"/>
							<div v-else>2</div>
							<div>验证身份</div>
						</div>
						<div class="forget-step-dian flex-center flex-midden">
							<span :class="step >= 3?'active':''"></span>
							<span :class="step >= 3?'active':''"></span>
							<span :class="step >= 3?'active':''"></span>
							<span :class="step >= 3?'active':''"></span>
						</div>
						<div class="flex-start flex-center" :class="step >= 3?'forget-step-active':'forget-step-item'">
							<img v-if="step >= 3" src="@/assets/images/dui2.png"/>
							<div v-else>3</div>
							<div>设置新密码</div>
						</div>
						<div class="forget-step-dian flex-center flex-midden">
							<span :class="step >= 4?'active':''"></span>
							<span :class="step >= 4?'active':''"></span>
							<span :class="step >= 4?'active':''"></span>
							<span :class="step >= 4?'active':''"></span>
						</div>
						<div class="flex-start flex-center" :class="step >= 4?'forget-step-active':'forget-step-item'">
							<img v-if="step >= 4" src="@/assets/images/dui2.png"/>
							<div v-else>4 </div>
							<div>完成</div>
						</div>  
					</div>
				
					<div class="step-one" v-if="step == 1">
						<el-form :model="ruleForm" :rules="rules" ref="oneForm" label-width="120px">
						  <el-form-item label="用户名称" prop="account">
								<el-input v-model="ruleForm.account" placeholder="手机号码/用户名称"></el-input>
						  </el-form-item>
						  <el-form-item label="验证码" prop="code">
								<el-input v-model="ruleForm.code" placeholder="输入图形验证码"></el-input>
						  </el-form-item>
						</el-form>
						
						<div class="image-show flex-start flex-center">
							<img :src="image"/>
							<div>看不清？<span @click="getImage">换一张</span></div>
						</div>
						
						
						<el-button class="login-button" type="primary" :loading="isSubmit" @click="oneSubmit()">下一步</el-button>
					</div>
					
					
					<div class="step-one" v-if="step == 2">
						<el-form :model="ruleForm" :rules="rules" ref="twoForm" label-width="120px">
						  <el-form-item label="用户名称" prop="showAccount">
								<el-input v-model="ruleForm.showAccount" disabled placeholder="用户名称"></el-input>
						  </el-form-item>
						  <el-form-item label="手机号码" prop="showPhone">
								<el-input v-model="ruleForm.showPhone" disabled placeholder="手机号码">
									<div slot="suffix" class="msg-notice">*若该手机号已无法使用请联系客服</div>
								</el-input>
						  </el-form-item>
						  
						  <el-form-item label="验证码" prop="smscode">
								<el-input v-model="ruleForm.smscode" placeholder="短信验证码">
									<div slot="suffix" class="send-code" v-if="send">{{time}}S</div>
									<div slot="suffix" class="send-code" v-else @click="sendCode">获取验证码</div>
								</el-input>
						  </el-form-item>
						</el-form>
						
						<el-button class="login-button" type="primary" :loading="isSubmit" @click="twoSubmit()">下一步</el-button>
					</div>
					
					
					
					<div class="step-one" v-if="step == 3">
						<el-form :model="ruleForm" :rules="rules" ref="threeForm" label-width="120px">
						  <el-form-item label="新的密码" prop="password">
								<el-input v-model="ruleForm.password" type="password" placeholder="设置6至20位登录密码"></el-input>
						  </el-form-item>
						  <el-form-item label="重置密码" prop="samePassword">
								<el-input v-model="ruleForm.samePassword" type="password" placeholder="设置6至20位登录密码"></el-input>
						  </el-form-item>
						</el-form>
						
						<el-button class="login-button" type="primary" :loading="isSubmit" @click="threeSubmit()">下一步</el-button>
					</div>
					
					<div v-if="step == 4">
						<div class="register-three">
							<img src="@/assets/images/dui.png"/>
							<div class="register-three-title">密码重置成功</div>
							<div class="register-three-desc"></div>
							<div class="register-three-button" @click="toLast">返回</div>
						</div>
					</div>
				</div>
			</div>
	
		</div>
	</div>
</template>

<script>
	import {getCaptchaCode,checkCaptchaCode,smsCode,checkAccount,resetPassword} from "@/api/login"
	export default {
		data(){
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
				  callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.password) {
				  callback(new Error('两次输入密码不一致!'));
				} else {
				  callback();
				}
			};
			var validatePass = (rule, value, callback) => {
				if (value === '') {
				  callback(new Error('请输入密码'));
				  
				} else if (!/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*.]{6,20}$/.test(value)) {
				  callback(new Error('密码必须是6-20位、必须含有字母、数字!'));
				} else {
				  callback();
				}
			};
			return {
				step:1,
				ruleForm:{
					account:"",
					code:"",
					key:"",
					showAccount:"",
					showPhone:"",
					smscode:"",
					password:"",
					samePassword:""
				},
				
				rules:{
					account:[
						{ required: true, message: '请输入手机号码/用户名称', trigger: 'blur' },
					],
					code:[
						{ required: true, message: '请输入图形验证码', trigger: 'blur' },
					],
					smscode:[
						{ required: true, message: '请输入短信验证码', trigger: 'blur' },
					],
					password: [
						{ validator: validatePass, trigger: 'blur' }
					],
					samePassword: [
						{ validator: validatePass2, trigger: 'blur' }
					],
				},
				image: "",
				isSubmit:false,
				send:false,
				time:0,
				timeFun:null,
				
			}
		},
		mounted() {
			this.getImage();
		},
		methods:{
			getImage(){
				getCaptchaCode().then(res=>{
					if(res.code == 1000){
						this.image = 'data:application/pdf;base64,'+res.data.imageBase64;
						this.ruleForm.key = res.data.key;
					}else{
						return this.$message.error(res.message);
					}
				})
			},
			//验证图形验证码是否正确
			oneSubmit(){
				this.$refs['oneForm'].validate((valid) => {
					if (valid) {
						this.isSubmit = true;
						checkCaptchaCode(this.ruleForm).then(res=>{
							if(res.code == 1000){
								this.ruleForm.showAccount = res.data.account;
								this.ruleForm.showPhone = res.data.phone;
								this.isSubmit = false;
								this.step = 2;
							}else{
								this.isSubmit = false;
								return this.$message.error(res.message);
							}
						})
					}
				});
			},
			//获取短信验证码
			sendCode(){
				if(this.send){return false;}
				if(this.ruleForm.showPhone == ""){
					return this.$message.error("请输入手机号");
				}
				let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
				if(!reg.test(this.ruleForm.showPhone)){
					return this.$message.error("请输入正确的手机号");
				}			
				smsCode({phone:this.ruleForm.showPhone,type:3}).then(res=>{
					if(res.code == 1000){
						this.send = true;
						this.time = 60;
						this.changeTime();
					}else{
						return this.$message.error(res.message);
					}
				})
				
			},
			changeTime(){
				if(this.timeFun != null){
					clearTimeout(this.timeFun);
				}
				this.timeFun = setTimeout(()=>{
					this.time--;
					if(this.time > 0){
						this.changeTime();
					}else{
						this.send = false;
					}
				},1000);
			},
			//第二部提交数据
			twoSubmit(){
				this.$refs['twoForm'].validate((valid) => {
					if (valid) {
						this.isSubmit = true;
						checkAccount({
							account:this.ruleForm.showAccount,
							phone:this.ruleForm.showPhone,
							code:this.ruleForm.smscode
						}).then(res=>{
							if(res.code == 1000){
								this.isSubmit = false;
								this.step = 3;
							}else{
								this.isSubmit = false;
								return this.$message.error(res.message);
							}
						})
					}
				});
			},
			//第三步提交数据
			threeSubmit(){
				this.$refs['threeForm'].validate((valid) => {
					if (valid) {
						this.isSubmit = true;
						resetPassword({
							phone:this.ruleForm.showPhone,
							password:this.ruleForm.password,
							samePassword:this.ruleForm.samePassword
						}).then(res=>{
							if(res.code == 1000){
								this.step = 4;
							}else{
								this.isSubmit = false;
								return this.$message.error(res.message);
							}
						})
					}
				});
			},
			toLast(){
				window.history.go(-1);
			}
		}
	}
</script>
<style scoped lang="scss">
	@import url("../assets/user.scss");
	.msg-notice{
		height: 22px;
		font-weight: 400;
		font-size: 14px;
		color: #E91A12;
		line-height: 22px;
		width: 220px;
		text-align: center;
		position: absolute;
		top: 50%;
		right: -232px;
		margin-top: -11px;
	
	}
	.send-code{
		height: 22px;
		font-weight: 400;
		font-size: 16px;
		color: rgba(233, 26, 18, 1);
		line-height: 22px;
		width: 120px;
		text-align: center;
		position: absolute;
		top: 50%;
		right: 0px;
		margin-top: -11px;
		cursor: pointer;
	}
	.step-one{
		width: 540px;
		margin: 0 auto;
		::v-deep .el-form-item__label{
			font-size: 16px;
			color: #9E9E9E;
			&::before{
				display: none;
			}
		}
		::v-deep .el-input__inner{
			width: 420px;
			height: 48px;
			border: 1px solid rgba(7, 11, 19, 0.1);
		}
		.image-show{
			margin: 0px 0px 40px 120px;
			img{
				width: 96px;
				height: 40px;
				object-fit: contain;
			}
			div{
				font-size: 16px;
				line-height: 22px;
				color: #9E9E9E;
				cursor: pointer;
				margin-left: 16px;
				span{
					color: #E91A12;
				}
			}
		}
		.login-button{
			margin-left: 120px;
			width: 420px;
			height: 46px;
			background: #E91A12;
			font-size: 16px;
			font-weight: 500;
			color: #FFFFFF;
			border: 0px;
			margin-top: 20px;
		}
	}
	.forget-step{
		margin-bottom: 40px;
		.forget-step-dian{
			padding: 0px 15px;
			span{
				width: 4px;
				height: 4px;
				background: #E8E8E8;
				border-radius: 100%;
				display: block;
				margin: 0px 5px;
			}
			.active{
				background: rgba(233, 26, 18, 1);
			}
		}
		.forget-step-active{
			img{
				width: 28px;
				height: 28px;
				margin-right: 12px;
				flex: 0 0 28px;
			}
			div{
				font-size: 16px;
				line-height: 24px;
				color: #1D2129;
			}
		}
		.forget-step-item{
			div{
				&:first-of-type{
					width: 28px;
					height: 28px;
					border-radius: 14px;
					background: #F2F3F5;
					margin-right: 12px;
					flex: 0 0 28px;
					font-size: 16px;
					line-height: 28px;
					color: #4E5969;
					text-align: center;
				}
				&:last-of-type{
					font-size: 16px;
					line-height: 24px;
					color: rgba(78, 89, 105, 1);
				}
			}
		}
	}
	.forget-title{
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #070B13;
		padding: 20px 40px 60px;
	}
	.register-three{
		text-align: center;
		padding-top: 30px;
		img{
			width: 64px;
			height: 64px;
		}
		.register-three-title{
			font-size: 18px;
			line-height: 24px;
			color: #070B13;
			margin-top: 20px;
		}
		.register-three-button{
			width: 260px;
			height: 46px;
			border: 1px solid rgba(233, 26, 18, 0.1);
			font-size: 16px;
			font-weight: 500;
			line-height: 46px;
			text-align: center;
			color: #070B13;
			margin: 40px auto 0px;
			cursor: pointer;
		}
	}
</style>